import React from 'react'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import {
  StyledButton,
  type StyledButtonProps,
} from '~/components/elements/StyledButton'

import { type InputValues } from '../utils'

export type SegmentRoutesClearButtonProps = {
  index: number
}

export const SegmentRoutesClearButton = ({
  index,
}: SegmentRoutesClearButtonProps) => {
  const { t } = useTranslation()
  const name = React.useMemo(
    () => `strategies.${index}.segmentRoutes` as const,
    [index],
  )
  const { setValue, watch } = useFormContext<InputValues>()
  const segmentRoutes = watch(name)

  const handleClick = React.useCallback<
    EH<StyledButtonProps, 'onClick'>
  >(() => {
    setValue(name, [])
  }, [name, setValue])

  if (segmentRoutes.length === 0) {
    return null
  }

  return (
    <StyledButton fillMode="flat" onClick={handleClick}>
      {t('clear_selection')}
    </StyledButton>
  )
}
